import { gql, useMutation } from '@apollo/client';

export const CHANGE_STRIPE_ACCOUNT_ADDRESS = gql`
  mutation changeStripeAccountAddress($payload: StripeAddressInput!) {
    changeStripeAccountAddress(payload: $payload)
  }
`;

export const useChangeStripeAccountAddress = () => {
  const [changeStripeAccountAddress, { loading }] = useMutation(CHANGE_STRIPE_ACCOUNT_ADDRESS);

  return { changeStripeAccountAddress, loading };
};
